import { utcIsoToZonedParts } from '@eureca/ui';
import { APP_TIMEZONE } from '@/lib/timezone';

/**
 * `expiresAt` é um INSTANTE (ISO UTC) — renderiza como wall-clock no fuso do
 * app (America/Sao_Paulo, padrão do recruiter — ver date-timezone-standard),
 * via o helper canônico `utcIsoToZonedParts` (TZDate, DST-correct).
 *
 * Formato do PFC-025: `Link disponível até {dd/mm/aaaa}, às {hh:mm}.`
 */
export function formatShareExpiryLabel(expiresAt: string): string | null {
  const { date, time } = utcIsoToZonedParts(expiresAt, APP_TIMEZONE);
  if (!date || !time) return null;
  const [year, month, day] = date.split('-');
  return `Link disponível até ${day}/${month}/${year}, às ${time}.`;
}
